import type { JSX } from 'react';
import { Tabs as AntTabs, TabsProps } from 'antd';
import classNames from 'classnames';

import './Tabs.scss';

interface Props extends TabsProps {
  className?: string;
  containerClassName?: string;
}

export const Tabs = ({
  items,
  containerClassName,
  className,
  defaultActiveKey = '1',
  onChange,
  ...props
}: Props): JSX.Element => {
  return (
    <div data-testid="tabs-container" className={classNames('custom-tabs', [containerClassName])}>
      <AntTabs
        {...props}
        className={classNames('custom-tabs__tabs', [className])}
        data-testid="tabs"
        defaultActiveKey={defaultActiveKey}
        items={items}
        onChange={onChange}
      />
    </div>
  );
};
